import { ApolloClient, gql, NormalizedCacheObject, QueryHookOptions, useQuery } from '@apollo/client'
import { GetListsQuery, GetListsQueryVariables } from 'types/graphql'
import { brandRowFieldsFragment } from 'modules/brands/list/queries/getDiscoveryBrands'
import { listFieldsFragment } from './list'

export const getListsQuery = gql`
  ${brandRowFieldsFragment}
  ${listFieldsFragment}
  query GetLists($listIds: [ID!]) {
    lists(listIds: $listIds) {
      ...ListFields
      user {
        id
        fullName
        username
      }
      brands {
        items {
          ...BrandRowFields
        }
        total
        hasMore
        nextSkip
      }
    }
  }
`

export const useLists = (options: QueryHookOptions<GetListsQuery, GetListsQueryVariables>) => {
  return useQuery<GetListsQuery, GetListsQueryVariables>(getListsQuery, options)
}

export const preloadLists = ({ apolloClient, listIds }: { apolloClient: ApolloClient<NormalizedCacheObject>; listIds: string[] }) => {
  return apolloClient.query<GetListsQuery, GetListsQueryVariables>({
    query: getListsQuery,
    variables: { listIds }
  })
}
